import classes from "./AuthLoader.module.css";

export default function AuthLoader() {
  return (
    <>
      <span className={`${classes.loader}`}></span>
    </>
  );
}
